var exports = {
  "iE": "xaee3c4fa--0b1898--wrapper",
  "su": "xaee3c4fa--0b1898--icon-wrapper",
  "o5": "xaee3c4fa--0b1898--content-wrapper",
  "$U": "xaee3c4fa--0b1898--headnote",
};

module.exports = exports;
